import React, { useEffect } from 'react';
// import { useFirestoreConnect } from "react-redux-firebase";
import { Layout, Row, Col, Table, Card, Badge, Statistic, Tooltip } from 'antd';
import SideNav from '../../../Layout/SideNav';
// import { getGsmPlantData, getSensor } from "../../../modules/sensors/queries";
import HeaderBar from '../../../Layout/HeaderBar';
import { Content } from 'antd/lib/layout/layout';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../../store';
import { useParams } from 'react-router';
import { fetchSensor } from '../../../modules/sensors/actions';
import useLatestGsmPlantLog, {
  useBaseGsmPlantSchema,
  useGsmPlantLog,
} from './useLatestGsmPlantLog';
import { addDays, format, subDays } from 'date-fns';
import UsageChart from './UsageChart';
import UsageCard from './UsageCard';
import AlertCard from './AlertCard';
import OperationCard from './OperationCard';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TFunction, useTranslation } from 'react-i18next';
import AlertLogsContainer from './AlertLogsContainer';
import { useAppSelector } from '../../../hooks';
import { useCustomSchema } from './useCustomSchema';
import SensorInternalOverview from '../components/SensorInternalOverview';
import { InternalSchemaEditor, InternalSchemaDiagnostics } from '../components/InternalSchemaTools';
import InternalSchemaFieldIndicator from './InternalSchemaFieldIndicator';

/**
 * GSM plant schema:
 *  Module
    Timestamp
    // ALARMS
    Nodtryk (BM VM WORD96)
    Alarm (BM DM58)
    Binder Mangel (BM DI8)
    Noedtryk (BM DI4)
    Termo fejl (BM DI5)
    Vand mangel (BM VM DWORD32)
    // mængde
    Mix 1/1000 (BM VM DWORD100)
    Bindermiddel total L. (BM VM DWORD50)
    Vand 1000L (BM VM DWORD104)
    Vand 1L (BM VM DWORD108)
    // tid
    Pumpe drift tid (BM VM WORD56)
    Varme ON total tid (BM VM DWORD92)
    Temp Ude (BM VM WORD90)
    Kompressor drift tid
    // what type is this?
    Service  tryk pumpe
    Service  kompressor
 */

export default function GSMPlantContainer() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { orgId, sensorId } = useParams<{ orgId: string; sensorId: string }>();

  // using to temp map to "rapport" = "1" as some are named differently
  const rapportMapping = useAppSelector((state) => state.sensors.currentSensor?.rapportMapping);

  // Load custom schema from Firestore
  const {
    customSchema,
    metadata,
    isLoading: loadingCustomSchema,
    saveCustomSchema,
  } = useCustomSchema(orgId, sensorId);

  console.log({ rapportMapping });

  const { isLoading, data } = useLatestGsmPlantLog({
    deviceId: sensorId,
    rapportMapping,
  });
  const { isLoading: loadingLogs, data: dataLogs } = useGsmPlantLog({
    deviceId: sensorId,
    rapportMapping,
  });
  // TODO: move schema to DB
  // const { baseSchema } = useBaseGsmPlantSchema();
  useEffect(() => {
    dispatch(fetchSensor({ orgId, sensorId }));
    return () => {};
  }, [orgId, sensorId, dispatch]);

  // Filter out _metadata from customSchema for type safety
  const { _metadata, ...customSchemaFields } = customSchema;

  // Merge static schema with custom schema (or use only custom if toggle is on)
  const mergedSchema = metadata.useOnlyCustomSchema
    ? customSchemaFields
    : { ...schemaMapping, ...customSchemaFields };

  const source = mapToSchemaArray(
    dataLogs,
    mergedSchema as SchemaMapping,
    ignoreKeys,
    t,
    customSchemaFields as SchemaMapping,
    schemaMapping
  );

  const missingKeysFromLog = Object.keys(data)
    .filter((key) => !mergedSchema[key])
    .filter((key) => !ignoreKeys.includes(key))
    .sort((a, b) =>
      a.localeCompare(b, 'da', {
        sensitivity: 'base',
        numeric: true,
      })
    );

  // get most recent log
  const mostRecentLog = dataLogs?.[0];

  return (
    <>
      <SideNav />
      <Layout>
        <HeaderBar />
        <Content style={{ margin: '50px 24px 0' }}>
          <SensorInternalOverview orgId={orgId} sensorId={sensorId} sensorType="GSM_PLANT" />
          <Row gutter={16}>
            <Col md={12} xs={24} style={{ marginBottom: 20 }}>
              {/* {!phoneNumber && (
                                <>
                                    <AlertCard isLoading={isLoading} data={data} />
                                    <div style={{ marginTop: 20 }} />
                                </>
                            )} */}
              {/* {phoneNumber && ( */}
              {/* <> */}
              <AlertLogsContainer deviceId={sensorId} />
              <div style={{ marginTop: 20 }} />
              {/* </> */}
              {/* )} */}
              <Card bordered={false}>
                <UsageChart
                  // sensorId={sensorId}
                  isLoading={loadingLogs}
                  data={dataLogs.slice(0, 8)}
                />
              </Card>
            </Col>
            <Col md={12} xs={24}>
              <UsageCard isLoading={isLoading} data={mostRecentLog} />
              <div style={{ marginTop: 20 }} />
              <OperationCard isLoading={isLoading} data={mostRecentLog} />
              <div style={{ marginTop: 20 }} />

              {/* {columns && <Table dataSource={source} columns={columns} />} */}
            </Col>
            <Col md={24} xs={24}>
              {/* Write table of schemed */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <h1>Log skema: viser alle rå logs (seneste 30)</h1>
                <InternalSchemaEditor
                  variant="gsm"
                  customSchema={customSchema}
                  metadata={metadata}
                  onSave={saveCustomSchema}
                />
              </div>
              {/* <pre>{JSON.stringify(schemed, null, 2)}</pre> */}
              <Card>
                <Table dataSource={source.dataSource} columns={source.columns} pagination={false} />
                <InternalSchemaDiagnostics
                  missingKeys={missingKeysFromLog}
                  title="Anlæg logs som mangler forklaring:"
                />
                {/* <pre>{JSON.stringify(dataLogs[0], null, 2)}</pre> */}
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
}

type SchemaMapping = {
  [key: string]: { rawField?: string; title: string; explainer: string };
};

// TODO: make title and explainer translatable keys
const schemaMapping: SchemaMapping = {
  alarm: {
    title: 'Alarmstatus',
    explainer: `Alarm for støvbinder fejl
1 = der er en alarm om støvbinder fejl
0 = der er IKKE en alarm om støvbinder fejl
Ved fejl tjekkes binder_mangel, noedtryk, vand_mangel, termo_fejl, binder_fejl, vand_fejl, min_flow, max_flow`,
  },
  auto_start: {
    title: 'Auto start',
    explainer: 'Tæller antal gange anlægget er startet automatisk',
  },
  binder_mangel: {
    title: 'Binder mangel',
    explainer:
      'Binder shortage | 0 = der er IKKE en alarm om støvbinder | 1 = der er en alarm om støvbinder mangel',
  },
  binde_total_l: {
    title: 'Total Støvbinder forbrug',
    explainer: 'Total usage of binder',
  },
  binder_fejl: {
    title: 'Binderfejl',
    explainer:
      'Binder error | 0 = der er IKKE en alarm om støvbinder | 1 = der er en alarm om støvbinder fejl',
  },
  binder_total_l: { title: 'Total binder i L', explainer: 'Total binder in liters' },
  binder_tom: { title: 'Binder tom', explainer: 'Binder is empty' },
  bånd_start: { title: 'Bånd start', explainer: 'Båndet er start' },
  createTime: { title: 'Oprettelsestid', explainer: 'Creation time' },
  drift: { title: 'Drift', explainer: 'Drift' },
  dyse_v_antal: { title: 'Dyse V antal', explainer: 'Dyse V amount' },
  dyse_total_tid: { title: 'Dyse total tid', explainer: 'Dyse total time' },
  dyse_h_antal: { title: 'Dyse H antal', explainer: 'Dyse H amount' },
  errors: { title: 'Fejlliste', explainer: 'List of errors' },
  luft_timer: { title: 'Luft timer', explainer: 'Air timer' },
  kfaktor: { title: 'Kfaktor', explainer: 'K-factor' },
  module: { title: 'Modulnavn', explainer: 'Module name' },
  mix_1_1000: { title: 'Blanding 1 pr 1000', explainer: 'Mix 1 per 1000' },
  mix: { title: 'Blandingsmængde', explainer: 'Mix quantity' },
  max_flow: {
    title: 'Maksimal flow',
    explainer:
      'Maximum flow | 0 = der er IKKE en alarm om støvbinder | 1 = der er en alarm om støvbinder fejl',
  },
  min_flow: {
    title: 'Minimum flow',
    explainer:
      'Minimum flow | 0 = der er IKKE en alarm om støvbinder | 1 = der er en alarm om støvbinder fejl',
  },
  noedtryk: {
    title: 'Nødstop',
    explainer: 'Emergency stop | 1= nødtryk ok  0= Fejl, nogen har trykket på nødstoppet.',
  },
  orgId: { title: 'Organisations ID', explainer: 'Organization identifier' },
  pumpe: { title: 'Pumpe', explainer: 'Pump' },
  pumpe_dyser: { title: 'Pumpe dyser', explainer: 'Pump dyser' },
  pumpe_total: { title: 'Total pumpe', explainer: 'Total pump' },
  pumpe_total_tid: { title: 'Pumpe total tid', explainer: 'Pump total time' },
  pumpe_sprinkler: { title: 'Pumpe sprinkler', explainer: 'Pump sprinkler' },
  pumpe_påfyldning_tid: { title: 'Pumpe påfyldning tid', explainer: 'Pump påfyldning time' },
  pumpe_påfyldning: { title: 'Pumpe påfyldning', explainer: 'Pump påfyldning' },
  påfyldnings_fejl: { title: 'Påfyldnings fejl', explainer: 'Pump påfyldning error' },
  rapport: { title: 'Rapportstatus', explainer: 'Report status' },
  regn_sensor: { title: 'Regn sensor', explainer: 'Rain sensor 0 = OK 1 = Rain' },
  sensorId: { title: 'Sensor ID', explainer: 'Sensor identifier' },
  service: { title: 'Service', explainer: 'Service' },
  service_timer: { title: 'Service timer', explainer: 'Service timer' },
  start_tryk: { title: 'Start tryk', explainer: 'Anlægget er startet manuelt' },
  sprinkler_tid: { title: 'Sprinkler tid', explainer: 'Sprinkler time' },
  sprinkler_antal: { title: 'Sprinkler antal', explainer: 'Sprinkler amount' },
  stop_tryk: { title: 'Stop tryk', explainer: 'Anlægget er stoppet manuelt' },
  temp_ude: { title: 'Temp. Ude', explainer: 'Temperature outside (number / 10)' },
  temp_inde: { title: 'Temp. Inde', explainer: 'Temperature inside (number / 10)' },
  stopfjern1: { title: 'Stop fjern1', explainer: 'Stop fjern1' },
  stopfjern2: { title: 'Stop fjern2', explainer: 'Stop fjern2' },
  timestamp: { title: 'Tidsstempel', explainer: 'Timestamp' },
  timer_sprinkler_sek: { title: 'Timer sprinkler sek', explainer: 'Timer sprinkler seconds' },
  timer_dyser_sek: { title: 'Timer dyser sek', explainer: 'Timer dyser seconds' },
  termo_fejl: {
    title: 'Termofejl',
    explainer:
      'Thermo error | 1= Ingen fejl   0= termofejl, motorværn er udløst, vil genererer en alarm',
  },
  vand_total_1000_l: {
    title: 'Total vand i 1000 L',
    explainer: 'Total water in 1000 liters',
  },
  vand_total_100l: {
    title: 'Total vand i 100 L',
    explainer: 'Total water in 100 liters',
  },
  vand_fejl: {
    title: 'Vandfejl',
    explainer: 'Water error | 1= ingen fejl   0= Vand mangel, vil genererer en alarm',
  },
  vand_mangel: {
    title: 'Vandmangel',
    explainer:
      'Water shortage | 0 = der er IKKE en alarm om vandmangel | 1 = der er en alarm om vandmangel',
  },
  vand_mangel_antal: {
    title: 'Vandmangel antal',
    explainer: 'Water shortage count',
  },
  vand_total_l: { title: 'Total vand i L', explainer: 'Total water in liters' },
  vand_l: { title: 'Vand i L', explainer: 'Water in liters' },
  varme_on_total_tid: { title: 'Varme on total tid', explainer: 'Total time warm on' },
  ventil_1: { title: 'Ventil 1', explainer: 'Antal gange Sprinkler 1 har kørt. Talt op' },
  ventil_2: { title: 'Ventil 2', explainer: 'Antal gange Sprinkler 2 har kørt. Talt op' },
  ventil_3: { title: 'Ventil 3', explainer: 'Antal gange Sprinkler 3 har kørt. Talt op' },
  ventil_4: { title: 'Ventil 4', explainer: 'Antal gange Sprinkler 4 har kørt. Talt op' },
  ventil_5: { title: 'Ventil 5', explainer: 'Antal gange Sprinkler 5 har kørt. Talt op' },
};

function mapToSchemaArray(
  data: { [key: string]: any }[],
  mapping: SchemaMapping,
  ignoreKeys: string[] = [],
  t: TFunction<'translation', undefined>,
  customSchema: SchemaMapping,
  schemaMapping: SchemaMapping
): { columns: { title: string; dataIndex: string; key: string }[]; dataSource: any[] } {
  const columns: {
    title: string;
    dataIndex: string;
    key: string;
    fixed?: 'left';
    render?: any;
    width?: number;
  }[] = [
    {
      title: '',
      dataIndex: 'Field',
      key: 'Field',
      fixed: 'left',
      render: (key: any) => {
        console.log({ key });
        const field = mapping[key];
        const isCustomField = customSchema[key] !== undefined;
        const isDefaultField = schemaMapping[key] !== undefined;
        const tooltipContent = [
          field?.explainer,
          field?.rawField ? `\n\nRåfelt: ${field.rawField}` : '',
          `\nNøgle: ${key}`,
        ]
          .filter(Boolean)
          .join('');

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {field?.title}{' '}
            <Tooltip
              title={tooltipContent}
              overlayInnerStyle={{
                whiteSpace: 'pre-wrap',
                minWidth: '300px',
              }}
            >
              <InfoCircleOutlined />
            </Tooltip>
            <InternalSchemaFieldIndicator
              isDefaultField={isDefaultField}
              isCustomField={isCustomField}
            />
          </div>
        );
      },
    },
  ];
  const dataSource: any[] = [];

  // Gather unique timestamps and add them as columns
  // @ts-ignore
  const timestamps = [...new Set(data.map((item) => item.timestamp))];
  for (const timestamp of timestamps) {
    console.log({ timestamp });
    const date = new Date(timestamp);
    columns.push({
      title: t('date.exactFormatWithYear', {
        relativeTime: date,
        dayOfWeek: date,
        dayOfMonth: date,
        month: date,
        time: date,
        year: date,
      }),
      dataIndex: timestamp,
      key: timestamp,

      // render: (v: any) => {
      //     console.log({ v });

      //     return v;
      // },
    });
  }

  // Gather fields and their corresponding values for each timestamp
  const orderedKeys = Object.keys(mapping)
    .filter((key) => !ignoreKeys.includes(key) && key !== 'timestamp')
    .sort((a, b) => {
      const titleA = mapping[a]?.title || a;
      const titleB = mapping[b]?.title || b;
      return titleA.localeCompare(titleB, 'da', { sensitivity: 'base' });
    });

  for (const key of orderedKeys) {
    if (mapping.hasOwnProperty(key)) {
      console.log({ key });

      const row: any = { Field: key };
      for (const timestamp of timestamps) {
        const item = data.find((d) => d.timestamp === timestamp);
        console.log({ [key]: item });

        row[timestamp] = item ? item[key] : '';
      }
      const hasKey = data.find((d) => d[key]);
      console.log({ [key]: hasKey, key, data });
      console.log({});
      if (hasKey) {
        dataSource.push(row);
      }
    }
  }

  return { columns, dataSource };
}

// function mapToSchemaArray(
//     data: { [key: string]: any }[],
//     mapping: SchemaMapping,
//     ignoreKeys: string[] = [],
// ): { columns: { title: string; dataIndex: string; key: string }[]; dataSource: any[] } {
//     const columns: { title: string; dataIndex: string; key: string }[] = [];
//     const dataSource: any[] = [];

//     // Gather columns from mapping in the defined order
//     const orderedKeys = Object.keys(mapping).filter(key => !ignoreKeys.includes(key));
//     for (const key of orderedKeys) {
//         if (mapping.hasOwnProperty(key)) {
//             columns.push({ title: mapping[key].title, dataIndex: key, key: key });
//         }
//     }

//     // Gather data rows in the defined order
//     for (const item of data) {
//         const row: any = {};
//         for (const key of orderedKeys) {
//             if (mapping.hasOwnProperty(key)) {
//                 row[key] = item[key] !== undefined ? item[key] : "";
//             }
//         }
//         dataSource.push(row);
//     }

//     return { columns, dataSource };
// }

const ignoreKeys = ['id', 'sensorId', 'orgId', 'errors', 'module', 'createTime'];
